/** Matches backend ProfilesSettingsVO (Jersey JSON). */

export type ProfileSettingKey = 'PROFILE_ASK' | 'PROFILE_WIDGETS' | 'PROFILE_SUBSCRIPTION' | 'INVITE_ONLY';

export interface ProfilesSettingsVO {
  companyId?: string;
  profileId?: string;
  updatedTs?: string | Date;
  updatedBy?: string;
  profileSettings?: ProfileSettingKey[];
  widgetList?: string[];
  /** HTML for invite-only Access Denied modal; blank/null → PROFILE_ACCESS_DENIED_DESCRIPTION */
  inviteOnlyAccessDeniedMessage?: string;
}

export const defaultProfilesSettings: ProfilesSettingsVO = {
  profileSettings: [],
  widgetList: [],
  inviteOnlyAccessDeniedMessage: ''
};

export const isProfileSettingEnabled = (settings: ProfilesSettingsVO | undefined, key: ProfileSettingKey): boolean =>
  Array.isArray(settings?.profileSettings) && settings?.profileSettings?.includes(key);
